import { render } from "./Txt.vue?vue&type=template&id=661c0c0f"
import script from "./Txt.vue?vue&type=script&lang=js"
export * from "./Txt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__